<div class="container">
  <div>
    <h1>{{ 'NGX-MESSAGING.' + errorMessage | translate }}</h1>
  </div>
</div>
